export class MaterialTipo {

  constructor(id: number){
    this.id = id;
  }

  id: number;
  nome: string;
}
